import _ from 'lodash';
import moment from 'moment-timezone';

export default class Campaign {
  constructor(data) {
    const defaults = {
      start: '0000-01-01 00:00:00',
      end: '9999-01-01 00:00:00',
      heading: { fi: '', en: '', ru: '' },
      body: { fi: '', en: '', ru: '' },
      serviceClassGroup: 'all',
      type: 'offer',
    };
    data = _.merge(defaults, data);
    this.start = moment(data.start, 'YYYY-MM-DD hh:mm:ss');
    this.end = moment(data.end, 'YYYY-MM-DD hh:mm:ss');
    this.ongoing = moment().isBetween(this.start, this.end);
    this.heading = data.heading;
    this.body = data.body;
    this.serviceClassGroup = data.serviceClassGroup;
    this.type = data.type;
  }
}
